var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { usePaymentMethodCreate } from "../Shared/hooks/PaymentMethodCreate/usePaymentMethodCreate";
import { usePaymentMethodUpdate } from "../Shared/hooks/PaymentMethodUpdate/usePaymentMethodUpdate";
/**
 * useAcceptHostedPost(setStatus) - Handles updating and adding a payment profile for a customer
 *
 * @returns
 */
export const useAcceptHostedPost = () => {
    const { createPaymentMethod, loading: createLoading } = usePaymentMethodCreate();
    const { updatePaymentMethod, loading: updateLoading } = usePaymentMethodUpdate();
    const handleUpdate = (body) => __awaiter(void 0, void 0, void 0, function* () {
        return yield updatePaymentMethod(body);
    });
    const handleAdd = (body) => __awaiter(void 0, void 0, void 0, function* () {
        return yield createPaymentMethod(body);
    });
    return { handleUpdate, handleAdd, loading: createLoading || updateLoading };
};
